import {
    PRESUPUESTADOR_DISABLE_BTN_SAVE_SUCCESS,
  } from '../constants';
  
  
  export function reducer(state, action) {
      if (action.type === PRESUPUESTADOR_DISABLE_BTN_SAVE_SUCCESS) {
          return {
              ...state,
              disableSave: true
          }
      }
      else {
          return state
      }
  }